"use client";

import React from 'react';
import { Dialog, DialogContent, CircularProgress, Typography, Stack, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const FullScreenLoader = ({ open, message = "Loading..." }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          opacity: 0.9,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          zIndex: theme.zIndex.modal + 1, // Ensure it's above other modals
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={60} color="primary" />
          <Typography variant="h6" color="text.primary" sx={{ textAlign: 'center' }}>
            {message}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenLoader;